import script from "./EditInput.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInput.vue?vue&type=script&setup=true&lang=js"

import "./EditInput.vue?vue&type=style&index=0&id=584c3c5c&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584c3c5c"]])

export default __exports__